import { useState } from "react";
import { apiUpdateCredentials } from "@/admin/adminApi";

const AccountTab = ({ email, onEmailChange }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    if (!newEmail && !newPassword) {
      setError("Enter a new email or a new password");
      return;
    }
    setBusy(true);
    try {
      const payload = { current_password: currentPassword };
      if (newEmail) {
        payload.new_email = newEmail;
      }
      if (newPassword) {
        payload.new_password = newPassword;
      }
      const res = await apiUpdateCredentials(payload);
      onEmailChange(res.data.email);
      setMessage("Account updated");
      setCurrentPassword("");
      setNewEmail("");
      setNewPassword("");
    } catch (err) {
      const detail = err.response && err.response.data && err.response.data.detail;
      setError(typeof detail === "string" ? detail : "Update failed");
    }
    setBusy(false);
  };

  return (
    <div data-testid="admin-tab-content-account">
      <div className="af-group af-group-static">
        <div className="af-group-body">
          <p className="af-hint-block">
            Signed in as <strong>{email}</strong>. Update your login email or password below.
            You will need your current password to make changes.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="af-field">
              <div className="af-field-head">
                <span className="af-label">Current password (required)</span>
              </div>
              <input
                className="af-input"
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                data-testid="admin-current-password-input"
                required
              />
            </div>
            <div className="af-grid-2">
              <div className="af-field">
                <div className="af-field-head">
                  <span className="af-label">New email (optional)</span>
                </div>
                <input
                  className="af-input"
                  type="email"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  data-testid="admin-new-email-input"
                />
              </div>
              <div className="af-field">
                <div className="af-field-head">
                  <span className="af-label">New password (optional, 8+ characters)</span>
                </div>
                <input
                  className="af-input"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  data-testid="admin-new-password-input"
                />
              </div>
            </div>
            {message && <p className="af-success" data-testid="admin-account-success">{message}</p>}
            {error && <p className="af-error" data-testid="admin-account-error">{error}</p>}
            <button type="submit" className="af-btn af-btn-primary" disabled={busy} data-testid="admin-account-save-btn">
              {busy ? "Saving..." : "Update Account"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AccountTab;
